import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import Box from '@material-ui/core/Box';
import BackspaceIcon from '@material-ui/icons/Backspace';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import Snackbar from '@material-ui/core/Snackbar';
import DateFnsUtils from '@date-io/date-fns';
import { isValid, format } from 'date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import Today from '@material-ui/icons/Today';
import MuiAlert from '@material-ui/lab/Alert';
import { useParams } from 'react-router';
import CancelIcon from '@material-ui/icons/Cancel';
import { v4 as uuid } from 'uuid';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

function Alert(props) {
	return <MuiAlert elevation={6} variant='filled' {...props} />;
}

function resetPage() {
	let url = window.location.href;
	let split = url.split('#/');
	window.location.href = split[0] + '#/';
	window.location.reload();
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		color: theme.palette.text.secondary,
	},
	container: {
		padding: theme.spacing(2),
		color: theme.palette.text.secondary,
	},
	button: {
		margin: theme.spacing(2),
	},
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: '2px solid #000',
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
	},
	textlable: {
		color: theme.palette.text.secondary,
		opacity: 0.5,
		fontWeight: 400,
		'&.focused': {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
		'&.shrink': {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
	},
	textInput: {
		color: theme.palette.text.secondary,
	},
	lable: {
		color: theme.palette.text.secondary,
		fontWeight: 400,
		opacity: 0.5,
		'&.Mui-focused': {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
	},
	datePickerInput: {
		color: theme.palette.text.secondary,
		fontWeight: 400,
		'&.Mui-focused': {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
	},
	labelShrink: {
		color: theme.palette.text.secondary,
		opacity: 1,
	},
}));

const NewEntry = (props) => {
	const { newEntryData, visiterData, employeeData, isLogin, actions, isLoaded, isUpdated, isDeleted } = props;
	const formatDate = (date) => format(date, 'MM/dd/yyyy');
	const classes = useStyles();
	const [first_name, setFirstName] = React.useState('');
	const [organization, setOrganization] = React.useState('');
	const [mobile_number, setMobileNumber] = React.useState('');
	const [email_address, setEmailAddress] = React.useState('');
	const [to_visit, setToVisit] = React.useState('');
	const [visit_date, setVisitDate] = React.useState(formatDate(new Date()));
	const [visit_time, setVisitTime] = React.useState(new Date());
	const [to_team, setToTeam] = React.useState('');
	const [to_visitLong, setToVisitLong] = React.useState('');
	const [visit_purpose, setVisitPurpose] = React.useState('');
	const [visit_note, setVisitNote] = React.useState('');
	const [employeeListShow, setEmployeeListShow] = React.useState('');
	const [movement_id, setMovementId] = React.useState('');
	const [openAlert, setOpenAlert] = React.useState('');
	const [alertText, setAlertText] = React.useState('');
	const [severityType, setSeverityType] = React.useState('');
	const [visitor_id, setVisitorId] = React.useState('');

	const handleChangeFirstName = (event) => {
		setFirstName(event.target.value);
	};

	const handleChangeToVisit = (event) => {
		const selUser = employeeData.filter((g) => g.emp_login === event.target.value)[0];
		if (selUser.is_vacation === 'Y') {
			const a_text = `The employee selected is out of office. ${event.currentTarget.innerText} will be back on ${selUser.next_available_date}`;
			setOpenAlert(true);
			setAlertText(a_text);
			setSeverityType('info');
		} else {
			setToVisit(event.target.value);
			setToVisitLong(event.currentTarget.innerText);
		}
	};

	const handleDateChange = (date, value) => {
		const selDate = isValid(date) ? formatDate(date) : value;
		setVisitDate(selDate);
	};

	const handleVisitTimeChange = (date) => {
		const selDate = isValid(date) ? date : new Date();
		setVisitTime(new Date(selDate));
	};

	const handleChangeToTeam = (event) => {
		setToTeam(event.target.value);
		setEmployeeListShow(employeeData);
		let tempEmployeeData = employeeData;
		if (event.target.value === 'ea') {
			tempEmployeeData = tempEmployeeData.filter((g) => g.is_EA === 'Y');
		} else if (event.target.value === 'oa') {
			tempEmployeeData = tempEmployeeData.filter((g) => g.is_OA === 'Y');
		} else if (event.target.value === 'sa') {
			tempEmployeeData = tempEmployeeData.filter((g) => g.is_SA === 'Y');
		}
		setEmployeeListShow(tempEmployeeData);
	};

	const handleChangeOrganization = (event) => {
		setOrganization(event.target.value);
	};

	const handleChangeEmailAddress = (event) => {
		setEmailAddress(event.target.value);
	};

	const handleChangeVisitPurpose = (event) => {
		setVisitPurpose(event.target.value);
		setEmployeeListShow(employeeData);
	};

	const handleChangeVisitNote = (event) => {
		setVisitNote(event.target.value);
	};

	const handleClickBack = () => {
		props.handleBackClick();
	};

	const handleCancelRequest = () => {
		handleDeleteClose();
		const id = visitor_id;
		actions.deleteVisiterData(id);
	};

	const handleUpdateRequest = () => {
		let visitor_date = new Date(format(new Date(visit_date), 'MM/dd/yyyy') + ' ' + GetTime(visit_time));
		const date = new Date();
		if (visitor_date >= date) {
			const data = {
				id: visitor_id,
				name: first_name,
				organization: organization,
				mobile_number: mobile_number,
				email_address: email_address,
				visit_person: to_visit,
				visit_person_long: to_visitLong,
				visit_team: to_team,
				visit_purpose: visit_purpose == 'p' ? 'Personal' : 'Official',
				visit_note: visit_note,
				//visit_date: getCurrentDate(),
				visit_in_time: GetTime(visit_time),
				visit_date: visit_date,
				visit_out_time: '',
				//is_exit: false,
				movement_id: movement_id,
			};
			actions.updateVisiterTime(data);
		} else {
			setOpenAlert(true);
			setAlertText('Please select future date/time');
			setSeverityType('warning');
		}
	};

	const handleMobileNumberSelect = (event, newValue) => {
		if (newValue) {
			setFirstName(newValue.first_name);
			setOrganization(newValue.organization);
			setMobileNumber(newValue.mobile_number.toString());
			setEmailAddress(newValue.email_address);
			setMovementId(newValue.id);
		} else {
			setMovementId(0);
			setOrganization('');
			setFirstName('');
			setMobileNumber('');
			setEmailAddress('');
		}
	};

	const handleFirstNameSelect = (event, newValue) => {
		if (newValue) {
			setFirstName(newValue.first_name);
			setOrganization(newValue.organization);
			setMobileNumber(newValue.mobile_number.toString());
			setEmailAddress(newValue.email_address);
			setMovementId(newValue.id);
		} else {
			setMovementId(0);
			setOrganization('');
			setMobileNumber('');
			setFirstName('');
			setEmailAddress('');
		}
	};

	const getCurrentDate = (separator = '/') => {
		let newDate = new Date();
		let date = newDate.getDate();
		let month = newDate.getMonth() + 1;
		let year = newDate.getFullYear();

		return `${date < 10 ? `0${date}` : `${date}`}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
	};

	const GetTime = (date) => {
		//let date = new Date();
		let hour = date.getHours();
		let TimeType = hour <= 11 ? 'AM' : 'PM';
		if (hour > 12) {
			hour = hour - 12;
		}
		if (hour == 0) {
			hour = 12;
		}
		let minutes = date.getMinutes();
		if (minutes < 10) {
			minutes = '0' + minutes.toString();
		}

		let fullTime = hour.toString() + ':' + minutes.toString() + ' ' + TimeType.toString();
		return fullTime;
	};
	const alertRequired = (alertName, alertType) => {
		const a_text = alertType == 1 ? `Please enter the ${alertName}` : `Please select the ${alertName}`;
		setOpenAlert(true);
		setAlertText(a_text);
		setSeverityType('warning');
	};

	const isEmptyOrSpaces = (value) => {
		return value === undefined || value === null || value === '';
	};

	const validate = () => {
		let isValid_data = false;
		isValid_data = mobile_number.length > 0 ? true : false;
		if (!isValid_data) {
			alertRequired('mobile number', 1);
			return isValid_data;
		}
		isValid_data = first_name.length > 0 ? true : false;
		if (!isValid_data) {
			alertRequired('name', 1);
			return isValid_data;
		}
		// isValid_data = email_address.length > 0 ? true : false;
		// if(!isValid_data) {
		//     alertRequired('email address',1);
		//     return isValid_data;
		// }
		isValid_data = visit_purpose.length > 0 ? true : false;
		if (!isValid_data) {
			alertRequired('purpose of visit', 2);
			return isValid_data;
		}
		if (visit_purpose == 'p') {
			isValid_data = to_visit.length > 0 ? true : false;
			if (!isValid_data) {
				alertRequired('person to visit', 2);
				return isValid_data;
			}
			isValid_data = isEmptyOrSpaces(visit_date) || !isValid(new Date(visit_date)) ? false : true;
			if (!isValid_data) {
				alertRequired('visit date', 2);
				return isValid_data;
			}
			isValid_data = isEmptyOrSpaces(visit_time) || !isValid(new Date(visit_time)) ? false : true;
			if (!isValid_data) {
				alertRequired('visit time', 2);
				return isValid_data;
			}
		} else {
			isValid_data = to_team.length > 0 ? true : false;
			if (!isValid_data) {
				alertRequired('team', 2);
				return isValid_data;
			}
			isValid_data = to_visit.length > 0 ? true : false;
			if (!isValid_data) {
				alertRequired('person to visit', 2);
				return isValid_data;
			}
			isValid_data = isEmptyOrSpaces(visit_date) || !isValid(new Date(visit_date)) ? false : true;
			if (!isValid_data) {
				alertRequired('visit date', 2);
				return isValid_data;
			}
			isValid_data = isEmptyOrSpaces(visit_time) || !isValid(new Date(visit_time)) ? false : true;
			if (!isValid_data) {
				alertRequired('visit time', 2);
				return isValid_data;
			}
			isValid_data = organization.length > 0 ? true : false;
			if (!isValid_data) {
				alertRequired('organization name', 1);
				return isValid_data;
			}
		}
		return isValid_data;
	};

	const resetWindow = () => {
		setMovementId(0);
		setMobileNumber('');
		setFirstName('');
		setEmailAddress('');
		setVisitPurpose('');
		setToVisit('');
		setToVisitLong('');
		setToTeam('');
		setOrganization('');
		setVisitNote('');
		setVisitDate(formatDate(new Date()));
		setVisitTime(new Date());
	};

	const handleClickRequest = () => {
		const visitor_guid = uuid();
		const isValid_data = validate();
		let url = window.location.href;
		let split = url.split('#/');
		let loadUrl = split[0] + '#/';
		if (isValid_data) {
			const data = {
				name: first_name,
				organization: organization,
				mobile_number: mobile_number,
				email_address: email_address,
				visit_person: to_visit,
				visit_person_long: to_visitLong,
				visit_team: to_team,
				visit_purpose: visit_purpose == 'p' ? 'Personal' : 'Official',
				visit_note: visit_note,
				//visit_date: getCurrentDate(),
				visit_in_time: GetTime(visit_time),
				visit_date: visit_date,
				visit_out_time: '',
				//is_exit: false,
				movement_id: movement_id,
				visitor_guid: visitor_guid,
				url: loadUrl + visitor_guid,
			};
			//newEntryData = data;
			actions.insertNewEntry(data);
			actions.requestVisiterEntries();
			if (isLogin) {
				setOpenAlert(true);
				setAlertText('Your request submitted successfully');
				setSeverityType('success');
				props.handleRequestClick(data);
			} else {
				setOpenAlert(true);
				setAlertText('Your request submitted successfully');
				setSeverityType('success');
				resetWindow();
			}
		}
	};

	const handleChange = (e) => {
		if (e.target.value) {
			const onlyNums = e.target.value.replace(/[^0-9]/g, '');
			if (onlyNums.length <= 10) {
				setMobileNumber(onlyNums);
			} else if (onlyNums.length === 10) {
				const number = onlyNums.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
				setMobileNumber(number);
			}
		} else {
			setMobileNumber('');
		}
	};

	const handleClose = () => {
		setOpenAlert(false);
		setAlertText('');
		setSeverityType('');
	};

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleDeleteClose = () => {
		setOpen(false);
	};

	let { id } = useParams();
	const [disabled, setDisabled] = React.useState(false);

	const [isFirstLoad, setFirstLoad] = React.useState(true);

	useEffect(() => {
		if (isFirstLoad) {
			if (id != undefined) {
				actions.getVisitorData(id);
				console.log('isLoaded');
				console.log(isLoaded);
				console.log('isLoaded');
				if (isLoaded.length > 0) {
					const e_data = isLoaded[0];
					let date = new Date();
					let visitor_date = new Date(format(new Date(e_data.visit_date), 'MM/dd/yyyy') + ' ' + e_data.visit_in_time);
					if (visitor_date >= date && e_data.is_exit == null) {
						setVisitorId(e_data.id);
						setFirstName(e_data.first_name);
						setMobileNumber(e_data.mobile_number);
						setEmailAddress(e_data.email_address);
						setMovementId(e_data.movement_id);
						let employeeDataTemp = [{ emp_login: e_data.visit_person, emp_name: e_data.visit_person_long }];
						setEmployeeListShow(employeeDataTemp);
						if (e_data.visit_purpose == 'Personal') {
							setVisitPurpose('p');
							setToVisit(employeeDataTemp[0].emp_login);
						} else if (e_data.visit_purpose == 'Official') {
							setVisitPurpose('o');
							setToTeam(e_data.visit_team);
							setToVisit(employeeDataTemp[0].emp_login);
							setOrganization(e_data.organization);
							setVisitNote(e_data.visit_note);
						}
						setVisitDate(format(new Date(e_data.visit_date), 'MM/dd/yyyy'));
						setVisitTime(new Date(visitor_date));
						setDisabled(true);
					} else {
						setTimeout(() => resetPage(), 1800);
						setOpenAlert(true);
						setAlertText('Your request is expired');
						setSeverityType('error');
					}
					actions.setIsLoaded(null);
					setFirstLoad(false);
				}
			}
		}

		if (isUpdated) {
			setOpenAlert(true);
			setAlertText('Your request updated successfully');
			setSeverityType('success');
			actions.setIsUpdated(false);
		}

		if (isDeleted) {
			setOpenAlert(true);
			setAlertText('Your request deleted successfully');
			setSeverityType('success');
			actions.setIsDeleted(false);
			setTimeout(() => resetPage(), 1800);
		}

		if (actions) {
			actions.requestVisiterList();
			actions.requestEmployeeList();
		}
	}, [actions, isLoaded, isUpdated, isDeleted]);

	return (
		<div className={classes.container}>
			<Grid container direction='row' justify='center' alignItems='center' spacing={3}>
				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<Autocomplete
							id='mobile_number'
							name='mobile_number'
							width='100%'
							disabled={disabled}
							options={visiterData}
							debug={true}
							freeSolo
							inputValue={mobile_number}
							onInputChange={handleChange}
							getOptionLabel={(option) => option.mobile_number.toString()}
							onChange={(event, newValue) => {
								handleMobileNumberSelect(event, newValue);
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									//label="Mobile Number*"
									placeholder='Mobile Number*'
									style={{ margin: 8 }}
									fullWidth
									margin='normal'
									InputLabelProps={{
										shrink: true,
									}}
									value={mobile_number}
									onChange={handleChange}
									variant='outlined'
								/>
							)}
							renderOption={(option, { inputValue }) => {
								let matches = match(option.mobile_number.toString(), inputValue);
								if (matches.length <= 0 && inputValue.length > 0) {
									let startIndex = option.mobile_number.toString().indexOf(inputValue);
									if (startIndex >= 0) {
										const searchIndex = [startIndex, startIndex + inputValue.length];
										matches.push(searchIndex);
									}
								}
								const parts = parse(option.mobile_number.toString(), matches);

								return (
									<div>
										{parts.map((part, index) => (
											<span
												key={index}
												style={{
													color: part.highlight ? '#36a5f7' : '',
													fontWeight: part.highlight ? 700 : 400,
												}}
											>
												{part.text}
											</span>
										))}
									</div>
								);
							}}
						/>
						<Autocomplete
							id='first_name'
							name='first_name'
							width='100%'
							options={visiterData}
							disabled={disabled}
							debug={true}
							freeSolo
							inputValue={first_name}
							getOptionLabel={(option) => option.first_name}
							onChange={(event, newValue) => {
								handleFirstNameSelect(event, newValue);
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									//label="Name*"
									placeholder='First Name and Last Name*'
									style={{ margin: 8 }}
									disabled={disabled}
									fullWidth
									margin='normal'
									InputLabelProps={{
										shrink: true,
									}}
									value={first_name}
									onChange={handleChangeFirstName}
									variant='outlined'
								/>
							)}
							renderOption={(option, { inputValue }) => {
								let matches = match(option.first_name.toLowerCase(), inputValue.toLowerCase());
								if (matches.length <= 0 && inputValue.length > 0) {
									let startIndex = option.first_name.toLowerCase().indexOf(inputValue.toLowerCase());
									if (startIndex >= 0) {
										const searchIndex = [startIndex, startIndex + inputValue.length];
										matches.push(searchIndex);
									}
								}
								const parts = parse(option.first_name, matches);

								return (
									<div>
										{parts.map((part, index) => (
											<span
												key={index}
												style={{
													color: part.highlight ? '#36a5f7' : '',
													fontWeight: part.highlight ? 700 : 400,
												}}
											>
												{part.text}
											</span>
										))}
									</div>
								);
							}}
						/>
						<TextField
							name='email_address'
							//label="Email Id"
							disabled={disabled}
							placeholder='Email Id'
							style={{ margin: 8 }}
							fullWidth
							margin='normal'
							InputLabelProps={{
								shrink: true,
							}}
							variant='outlined'
							value={email_address}
							onChange={handleChangeEmailAddress}
						/>
						<FormControl variant='outlined' className={classes.formControl} style={{ margin: 8 }} fullWidth>
							<InputLabel id='visit_purpose_label'>Purpose*</InputLabel>
							<Select labelId='visit_purpose_label' name='visit_purpose' value={visit_purpose} onChange={handleChangeVisitPurpose} label='Purpose' disabled={disabled}>
								<MenuItem value={'o'}>Official</MenuItem>
								<MenuItem value={'p'}>Personal</MenuItem>
							</Select>
						</FormControl>
						{visit_purpose === 'o' && (
							<FormControl variant='outlined' className={classes.formControl} style={{ margin: 8 }} fullWidth>
								<InputLabel id='to_team_label'>Team</InputLabel>
								<Select labelId='to_team_label' name='to_team' value={to_team} onChange={handleChangeToTeam} label='Team' disabled={disabled}>
									<MenuItem value={'ea'}>Engineering Admin</MenuItem>
									<MenuItem value={'oa'}>Office Admin</MenuItem>
									<MenuItem value={'sa'}>System Admin</MenuItem>
								</Select>
							</FormControl>
						)}
						{(visit_purpose === 'p' || (visit_purpose === 'o' && to_team !== '')) && (
							<FormControl variant='outlined' className={classes.formControl} style={{ margin: 8 }} fullWidth>
								<InputLabel id='to_visit_label'>To Visit</InputLabel>
								<Select labelId='to_visit_label' name='to_visit' value={to_visit} onChange={handleChangeToVisit} label='To Visit' disabled={disabled}>
									{employeeListShow.map((person) => (
										<MenuItem value={person.emp_login}>{person.emp_name}</MenuItem>
									))}
								</Select>
							</FormControl>
						)}
						{(visit_purpose === 'p' || (visit_purpose === 'o' && to_team !== '')) && (
							<FormControl variant='outlined' className={classes.formControl} style={{ margin: 8 }} fullWidth>
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										inputVariant='outlined'
										autoOk
										format={'dd/MM/yyyy'}
										labelId={'visit_date_label'}
										label={'Visit Date'}
										name={'visit_date'}
										onChange={(date, value) => {
											handleDateChange(date, value);
										}}
										autoComplete='new-password'
										autoComplete='password'
										value={visit_date}
										keyboardIcon={<Today fontSize='small' />}
										fullWidth
										KeyboardButtonProps={{
											'aria-label': 'change date',
											size: 'small',
										}}
										InputProps={{
											className: classes.datePickerInput,
										}}
										okLabel={<span style={{ color: 'white' }}>Ok</span>}
										cancelLabel={<span style={{ color: 'white' }}>CANCEL</span>}
										InputLabelProps={{
											classes: {
												root: classes.lable,
												shrink: classes.labelShrink,
											},
										}}
									></KeyboardDatePicker>
								</MuiPickersUtilsProvider>
							</FormControl>
						)}

						{(visit_purpose === 'p' || (visit_purpose === 'o' && to_team !== '')) && (
							<FormControl variant='outlined' className={classes.formControl} style={{ margin: 8 }} fullWidth>
								<MuiPickersUtilsProvider className={classes.zeroOutline} utils={DateFnsUtils}>
									<KeyboardTimePicker
										autoOk
										inputVariant='outlined'
										labelId={'visit_time_label'}
										label={'Visit Time'}
										name={'visit_time'}
										onChange={(date, value) => {
											handleVisitTimeChange(date, value);
										}}
										autoComplete='new-password'
										autoComplete='password'
										value={visit_time}
										keyboardIcon={<Today fontSize='small' />}
										fullWidth
										KeyboardButtonProps={{
											'aria-label': 'change time',
											size: 'small',
										}}
										InputProps={{
											className: classes.datePickerInput,
										}}
										okLabel={<span style={{ color: 'white' }}>Ok</span>}
										cancelLabel={<span style={{ color: 'white' }}>CANCEL</span>}
										InputLabelProps={{
											classes: {
												root: classes.lable,
												shrink: classes.labelShrink,
											},
										}}
									></KeyboardTimePicker>
								</MuiPickersUtilsProvider>
							</FormControl>
						)}
						{visit_purpose === 'o' && to_team !== '' && (
							<TextField
								name='organization'
								//label="Organization"
								placeholder='Organization'
								disabled={disabled}
								style={{ margin: 8 }}
								fullWidth
								margin='normal'
								InputLabelProps={{
									shrink: true,
								}}
								variant='outlined'
								value={organization}
								onChange={handleChangeOrganization}
							/>
						)}
						{visit_purpose === 'o' && to_team !== '' && (
							<TextField
								name='visit_note'
								//label="Note"
								placeholder='Note'
								style={{ margin: 8 }}
								fullWidth
								margin='normal'
								InputLabelProps={{
									shrink: true,
								}}
								multiline
								rows={4}
								variant='outlined'
								value={visit_note}
								onChange={handleChangeVisitNote}
							/>
						)}
						<Box display='flex' justifyContent='flex-end'>
							{isLogin && (
								<Button variant='contained' color='secondary' className={classes.button} startIcon={<BackspaceIcon />} onClick={handleClickBack}>
									Back
								</Button>
							)}
							{disabled && (
								<Button variant='contained' color='secondary' className={classes.button} endIcon={<SendIcon />} onClick={handleUpdateRequest}>
									Update
								</Button>
							)}
							{disabled && (
								<Button variant='contained' color='secondary' className={classes.button} endIcon={<CancelIcon />} onClick={handleClickOpen}>
									Cancel
								</Button>
							)}
							{!disabled && (
								<Button variant='contained' color='secondary' className={classes.button} endIcon={<SendIcon />} onClick={handleClickRequest}>
									Register
								</Button>
							)}
						</Box>
						<div>
							<Dialog open={open} onClose={handleDeleteClose}>
								<DialogTitle>Are you sure you want to delete your booking?</DialogTitle>

								<DialogActions>
									<Button onClick={handleCancelRequest} color='secondary'>
										Yes
									</Button>
									<Button onClick={handleDeleteClose} color='secondary' autoFocus>
										No
									</Button>
								</DialogActions>
							</Dialog>
						</div>
					</Paper>
				</Grid>
			</Grid>
			<Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
				<Alert onClose={handleClose} severity={severityType}>
					{alertText}
				</Alert>
			</Snackbar>
		</div>
	);
};

NewEntry.propTypes = {};

export default NewEntry;
